import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./SidebarMenu.css"; // custom CSS file
import Logo from '../assets/editortask_logo.png';
import { GrUserWorker } from "react-icons/gr";
import { MdOutlineWorkOutline } from "react-icons/md";
import { BsPersonWorkspace } from "react-icons/bs";
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import { BsInstagram } from 'react-icons/bs';
import { BsFacebook } from 'react-icons/bs';
import { BsYoutube } from 'react-icons/bs';
import { BsLinkedin } from 'react-icons/bs';
import { BsX } from 'react-icons/bs';
import { VscChromeClose, VscListSelection } from "react-icons/vsc";
const SidebarMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <>
      {/* Menu Button */}
      {/* <button className="menu-button" onClick={toggleMenu}>
        {isOpen ? <VscChromeClose /> : <VscListSelection />}
      </button> */}

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>


        <div className="sidebar-title" >
          <div className="logo_body" >
            <img className="logoimg" src={Logo} alt="Logo" />
            <div className='logo-text'>
              <b>Editor</b><br /><a className='logo-text2'>Task.com</a>
            </div>
          </div>
        </div>

        <div  >
          <table className="sidebar-links">
            <tr>
              <td>
                <div className="tab-title">Editortask</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='https://editortask.com/categories' title='Categories'>Categories</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" href='https://editortask.com/creative-portfolios' title='Creative portfolios'>Creative portfolios</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='https://editortask.com/hire-editors' title='Hire Editors'>Hire Editors</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" href='https://editortask.com/typing-master' title='Typing Master' >Typing Master</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Post Job' href='https://editortask.com/post-job'>Post Job</a>
              </td>
            </tr>
            <tr>
              <td>
                <div className="tab-title" >About</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='About' href='https://editortask.com/about'>About us</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='How it Works' href='https://editortask.com/how-it-works'>How it Works</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Security' href='https://editortask.com/security'>Security</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Sitemap' href='https://editortask.com/sitemap'>Sitemap</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" onClick={() => navigate('/help')}>Help & Support</a>
              </td>
            </tr>
            <tr>
              <td>
                <div className="tab-title">Terms</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Privacy Policy' href='https://editortask.com/privacy-policy'>Privacy Policy</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Terms and Conditions' href='https://editortask.com/terms-and-conditions'>Terms and Conditions</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Copyright Policy' href='https://editortask.com/copyright-policy'>Copyright Policy</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Code of Conduct' href='https://editortask.com/code-of-conduct'>Code of Conduct</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Fees and Charges' href='https://editortask.com/fees-and-charges'>Fees and Charges</a>
              </td>
            </tr>


            <tr>
              <td>
                <div className="tab-title">Business</div>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Partners' href='https://editortask.com/partners'>Partners</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Skills Showcase' href='https://editortask.com/skills'>Skills Showcase</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Locale Services' href='https://editortask.com/locale-services'>Locale Services</a>
              </td>
            </tr>
            <tr>

              <td>
                <a className="tab-link" title='Company profile' href='https://editortask.com/create-company-profile'>Company profile</a>
              </td>
            </tr>
            <tr>
              <td>
                <a className="tab-link" title='Business & Agency' href='https://editortask.com/agency'>Business & Agency</a>
              </td>
            </tr>

            <tr>
              <td>

                <div className="tab-link">
                  © <b>EditorTask -<br /> Kang Technology - {new Date().getFullYear()}</b><br /> All rights reserved  <br /><br /> <a>Update 1/04/2025</a>

                </div>
              </td>
            </tr>
          </table>

        </div>

      </div>

      {/* Overlay */}
      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </>
  );
};

export default SidebarMenu;
